export const EN_STRING_ALERT_BANNER_OVERRIDES = {
  // Domain + entity display name (shared key)
  ALERT_BANNERS: 'Alert Banners',
  ALERT_BANNER: 'Alert Banner',
  // Content group
  ALERT_BANNER_CONTENT: 'Content',
  ALERT_BANNER_CONTENT_TITLE: 'Title',
  ALERT_BANNER_CONTENT_BODY: 'Body',
  ALERT_BANNER_CONTENT_CTA_LABEL: 'CTA label',
  ALERT_BANNER_CONTENT_CTA_LINK: 'CTA link',
  ALERT_BANNER_CONTENT_CTA_LINK_HINT:
    'In-app deeplink or external URL. Opens in an in-app webview on mobile and a new tab on web.',

  // Display group (severity + dismissability + width)
  ALERT_BANNER_DISPLAY: 'Display Options',
  ALERT_BANNER_SEVERITY: 'Severity',
  ALERT_BANNER_SEVERITY_INFORMATIONAL: 'Informational',
  ALERT_BANNER_SEVERITY_WARNING: 'Warning',
  ALERT_BANNER_SEVERITY_CRITICAL: 'Critical',
  ALERT_BANNER_DISMISSABLE: 'Dismissable',
  ALERT_BANNER_DISMISSABLE_HINT: 'Members can close this banner.',
  ALERT_BANNER_FULL_WIDTH: 'Full width',
  ALERT_BANNER_FULL_WIDTH_HINT:
    'Banner spans the full screen width. Uncheck to inset it with the surrounding content.',

  // Schedule
  ALERT_BANNER_SCHEDULE: 'Schedule',
  ALERT_BANNER_SCHEDULE_START: 'Start date & time',
  ALERT_BANNER_SCHEDULE_END: 'End date & time',
  ALERT_BANNER_SCHEDULE_END_HINT: 'Leave empty to show indefinitely.',

  // Targeting group (platforms + cohort)
  ALERT_BANNER_TARGETING: 'Targeting',
  ALERT_BANNER_PLATFORM_TARGETING: 'Platform Targeting',
  ALERT_BANNER_PLATFORM_TARGETING_HINT:
    'Select the platforms on which this alert banner will appear',
  ALERT_BANNER_COHORT_TARGETING: 'Cohort Targeting',
  ALERT_BANNER_PLATFORMS: 'Platforms',
  ALERT_BANNER_ADD_PLATFORM: 'Add targeting platform',
  ALERT_BANNER_PLATFORM_IOS: 'iOS',
  ALERT_BANNER_PLATFORM_ANDROID: 'Android',
  ALERT_BANNER_PLATFORM_WEB: 'Web',
  ALERT_BANNER_COHORT: 'Cohort',
  ALERT_BANNER_COHORT_HINT:
    'Limit this banner to members in the selected cohort. Leave empty to show it to everyone.',

  // List view
  ALERT_BANNER_STATUS: 'Status',
  ALERT_BANNER_SEVERITY_INFORMATIONAL_DESCRIPTION:
    'Important information that is less critical',
  ALERT_BANNER_SEVERITY_WARNING_DESCRIPTION:
    'Notify members of planned maintenance and outages',
  ALERT_BANNER_SEVERITY_CRITICAL_DESCRIPTION:
    'High-urgency news alert to members',
};
